import React from 'react';
import PropTypes from 'prop-types';

import { staticFormControlTypes } from '../../../props/fieldProps';

import { InlineHelper } from '../../../helpers';
import { Label } from '../../utility';
import Helpblock from '../../utility/Helpblock';

const FormControlStatic = ({ value, label, tooltip, helptext, inline }) => (
	<div data-testid="form-control-static" className="row gx-2 mb-3">
		<Label tooltip={tooltip} className="col-auto">
			{label}
		</Label>
		<InlineHelper inline={inline}>
			<div data-testid="form-control-static-value">{value}</div>
			<Helpblock id="helpblockId" data-testid="helpblock-wrapper">
				{helptext}
			</Helpblock>
		</InlineHelper>
	</div>
);

FormControlStatic.propTypes = {
	label: PropTypes.string,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	tooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	helptext: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	inline: PropTypes.bool
};

FormControlStatic.displayName = 'FormControlStatic';

FormControlStatic.defaultProps = {
	...staticFormControlTypes
};

export default FormControlStatic;
